import classnames from 'classnames';
import Link       from '../components/link';
import React      from 'react';


//  Standalone button appears in its own section (eg sign out button)
//
//  label     - Button label
//  danger    — True for dangerous looking icon
//  href      - Navigate to this URL
//  onClick   - Event handler
export default function StandaloneButton({ label, danger = false, href, onClick, linkRef, external = false, className }) {
  const styleClassName = classnames('list-button', 'link', className, { 'color-red': danger });
  return (
    <div className="standalone-button list block">
      <ul>
        <li>
          <Link
            className={styleClassName}
            href={href}
            ref={linkRef}
            onClick={onClick}
            external={external}
          >
            {label}
          </Link>
        </li>
      </ul>
    </div>
  );
}
